<template>
  <div class="permissions-checkboxes">
    <div class="permissions-checkboxes__checkboxes" v-if="type !== 'view'">
      <Checkbox
        id="branded"
        v-model="permissionsForm.is_branded"
        :binary="true"
        @change="formHandler"
      />
      <label for="branded">This is a branded account</label>
    </div>
    <div class="permissions-checkboxes__checkboxes">
      <Checkbox
        id="can-dispatch"
        v-model="permissionsForm.can_dispatch"
        :binary="true"
        @change="formHandler"
        :trueValue="false"
        :falseValue="true"
        :disabled="type === 'view'"
      />
      <label for="can-dispatch">Disable load booking</label>
    </div>
    <div class="permissions-checkboxes__checkboxes">
      <Checkbox
        id="show-cost"
        v-model="permissionsForm.show_cost"
        :binary="true"
        @change="formHandler"
        :trueValue="false"
        :falseValue="true"
        :disabled="type === 'view'"
      />
      <label for="show-cost">Hide shipping cost once completed</label>
    </div>
    <div class="permissions-checkboxes__checkboxes"  v-if="type !== 'view'">
      <el-switch
      v-model="permissionsForm.is_active"
      @change="formHandler"> </el-switch>
      <label>
        Status:
        {{ permissionsForm.is_active ? "active" : "inactive" }}
      </label>
    </div>
  </div>
</template>

<script>
import Checkbox from "primevue/checkbox";

export default {
  name: "PermissionsCheckboxes",
  props: {
    accountInformation: Object,
    type: String
  },
  components: {
    Checkbox,
  },
  data() {
    return {
      permissionsForm: {},
    };
  },
  watch: {
    accountInformation: {
      immediate: true,
      handler(value) {
        if (typeof value === "object" && Object.keys(value).length > 0) {
          this.setPermissionsForm();
          this.formHandler();
        }
      },
    },
  },
  methods: {
    setPermissionsForm() {
      this.permissionsForm = {
        is_branded: this.accountInformation.is_branded,
        can_dispatch: this.accountInformation.can_dispatch,
        show_cost: this.accountInformation.show_cost,
        is_active: this.accountInformation.is_active,
      };
    },
    formHandler() {
      this.$emit("input", this.permissionsForm);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_mixin' as *;
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_mixin' as *;

.permissions-checkboxes {
  @include font-button-text;
  color: $color-primary-company;
  &__checkboxes {
    display: flex;
    &:not(:last-child) {
      margin-bottom: 5px;
    }
    label {
      margin-left: 10px;
    }
  }
}

::v-deep {
  .active {
    span {
      border-color: $color-border-container !important;
      background-color: $color-border-container !important;
    }
  }

  .el-switch.is-checked .el-switch__core {
    border-color: $color-border-container !important;
    background-color: $color-border-container !important;
  }
  .p-checkbox .p-checkbox-box {
    padding: 10px;
    border-radius: 6px;
    border: 1px solid $color-border-container;
  }
  .p-checkbox .p-checkbox-box.p-highlight {
    background: $color-border-container;
    background-color: $color-border-container;
    border-color: $color-border-container;
    &:hover {
      background: $color-border-container;
      background-color: $color-border-container;
      border-color: $color-border-container;
    }
  }
  .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-focus {
    border-color: $color-border-container;
    box-shadow: none;
  }
  .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {
    border-color: $color-border-container;
  }
}
</style>
